import { inject, Component, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { environment } from '@environment';
import { PaymentV2Service } from '@services/payment-v2/payment-v2.service';
import { VariablesService } from '@services/variables/variables.service';
import { PaymentService } from '@services/payment/payment.service';
import { InrFormatPipe } from '@pipes/inr-format/inr-format.pipe';

@Component({
  selector: 'app-payment-sip-donors',
  standalone: true,
  imports: [
    InrFormatPipe
  ],
  templateUrl: './payment-sip-donors.component.html',
  styleUrls: ['./payment-sip-donors.component.scss']
})
export class PaymentSipDonorsComponent {

  readonly payments = inject(PaymentService);
  public paymentv2 = inject(PaymentV2Service);
  public vars = inject(VariablesService);

  @Input() label = 'contributors are giving monthly';
  supporterImg;
  subs: Subscription[] = [];

  ngOnInit() {
    this.supporterImg = `/assets/images/random_supporters/${Math.floor(Math.random() * 10) + 1}.png`;
    this.payments.getSubsCount();
    this.subs.push(this.vars.subsCount.subscribe((res: any) => {
      this.paymentv2.sipDonors = res;
    }));
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }

}
